import {Modal} from "antd";
import React, {useEffect, useMemo, useState} from "react";
import {getTemplatePresets} from "../../../api/getTemplatePresets";
import useAppContext from "../../../hooks/useAppContext";
import useUserContext from "../../../hooks/useUserContext";
import "./presets-modal.css";
import {PresetGroupProps, PresetProps, PresetSubGroupProps} from "../../../types/PresetProps";
import Loader from "../../loader/Loader";
import PreviewPresets from "./PreviewPresets";
import {getTotalProductsApprovedForDiscount} from "../../../api/getTotalProductsApprovedForDiscount";
import Step4 from "../../messageCreationFlow/step4/Step4";
import GroupSelectors from "./GroupSelectors";
import PresetsExtraActions from "./PresetsExtraActions";
import {deActivateAllTemplates} from "../../../api/deActivateAllTemplates";
import {setDiscountForAllShopProducts} from "../../../api/setDiscountForAllShopProducts";
import useToast from "../../../hooks/useToast";
import {ToastSkin} from "../../../context/ToastContext";
import {createNotificationFromPresets} from "../../../api/createNotificationFromPresets";
import PresetsModalContent, {DISCOUNT_RATE_FOR_ALL} from "./PresetsModalContent";

interface PresetsModalProps {
    isOpen: boolean;
    onClose: (openCoupons?: boolean) => void;
    flowId: number;
}

export interface CouponApprovalStatus {
    total: number | null;
    totalApproved: number | null;
    totalUnApproved: number | null;
}

const PresetsModal = ({ isOpen, onClose, flowId }: PresetsModalProps) => {
    const [isLoading, setIsLoading] = useState(false);

    const onCreateNotificationFromPreset = () => {
        console.log("create");
    }

    const onCloseModal = () => {
        onClose();
    }

    return (
        <Modal
            open={isOpen}
            onOk={onCreateNotificationFromPreset}
            onCancel={onCloseModal}
            confirmLoading={isLoading}
            okButtonProps={{ style: { display: 'none' }}}
            cancelButtonProps={{ style: { display: 'none' }}}
            width={1024}
            destroyOnHidden={true}
            wrapClassName="presets-modal-wrapper"
        >
            <PresetsModalContent isOpen={isOpen} onClose={onClose} flowId={flowId} />
        </Modal>
    )
}

export default PresetsModal;